import React, {useCallback, useState} from 'react';

import * as S from '../EntityReport.styles';

type TeamReadmeModalProps = {onSave: () => void; onClose: () => void};

export const TeamReadmeModal: React.FC<TeamReadmeModalProps> = ({
  onSave,
  onClose,
  children,
}) => {
  const [warningOpen, setWarningOpen] = useState(false);

  const openWarning = useCallback(() => {
    setWarningOpen(true);
  }, []);

  const closeWarning = useCallback(() => {
    setWarningOpen(false);
  }, []);

  return (
    <S.Modal open onClose={openWarning}>
      <S.ModalHeader>
        <S.ModalSaveButton primary onClick={onSave}>
          Save
        </S.ModalSaveButton>
        <S.ModalCloseIcon name={`close`} onClick={openWarning} />
      </S.ModalHeader>
      {children}
      {warningOpen && (
        <S.ModalWarningOverlay>
          <S.ModalWarningContent>
            <S.ModalWarningText>
              Are you sure you want to exit without saving?
            </S.ModalWarningText>
            <S.ModalWarningActions>
              <S.ModalWarningButton primary onClick={closeWarning}>
                Resume
              </S.ModalWarningButton>
              <S.ModalWarningButton onClick={onClose}>
                Exit and discard
              </S.ModalWarningButton>
            </S.ModalWarningActions>
          </S.ModalWarningContent>
        </S.ModalWarningOverlay>
      )}
    </S.Modal>
  );
};
